var country = 'ca';
var mapAjaxUrl = 'https://tools.tbmbm.net/geodata/';
var catImages = [];
catImages['Vibrators'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-ClitoralStimulator.png?v=14245024808821453820';
catImages['Dildos'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-Dildo.png?v=10055797133214033000';
catImages['Male Masturbators'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-MaleMasturbator.png?v=10159396387297680785';
catImages['Bondage'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-Bondage.png?v=14330851221099645217';
catImages['Anal'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-ButtPlugs.png?v=16423544075516770728';
catImages['Lingerie'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-Lingerie.png?v=17228764115732853108';
var productJsonPool = [];
var productPool = [];
var maxProductShowing = 6;
var topProductContainer = ''; 


//List Of Categories We Want To Show
let CategoryName = ['Vibrators', 'Dildos','Male Masturbators','Bondage & Fetish','Anal Sex Toys','Lingerie'];

/*List Of Categories We Want To Show
Vibrators, Dildos, Male Masturbators, Bondage & Fetish, Anal Sex Toys, Lingerie
*/

var simplemaps_canadamap_mapdata={
  main_settings: {
    //General settings
	width: "500", //or 'responsive'
    background_color: "#FFFFFF",
    background_transparent: "yes",
    popups: "off",
    
	//State defaults
	state_description: "",
    state_color: "#F5D1D6",
    state_hover_color: "#e60060",
    border_size: 1.5,
    border_color: "#ffffff",
    all_states_inactive: "no",
    all_states_zoomable: "no",
    
	//Location defaults
	location_description: "Location description",
    location_color: "#00f",
    location_opacity: 0.5,
    location_hover_opacity: 0.5,
    location_url: "",
    location_size: 20,
    location_type: "circle",
    location_border_color: "#FFFFFF",
    location_border: 2,
    location_hover_border: 4,
    all_locations_inactive: "no",
    all_locations_hidden: "no",
    
	//Label defaults
	label_color: "#F5D1D6",
    label_hover_color: "#ffffff",
    label_size: 22,
    label_font: "Arial",
    hide_labels: "no",
    label_opacity: 0,
    label_hover_opacity: 1,
   
	//Zoom settings
	manual_zoom: "no",
    back_image: "yes",
    arrow_box: "no",
    navigation_size: "40",
    navigation_color: "black",
    navigation_border_color: "black",
    initial_back: "yes",
    initial_zoom: -1,
    initial_zoom_solo: "yes",
    region_opacity: 1,
    region_hover_opacity: 0.6,
    zoom_out_incrementally: "yes",
    zoom_percentage: 0.99,
    zoom_time: 0.5,
    
	//Popup settings
	popup_color: "white",
    popup_opacity: 0.9,
    popup_shadow: 1,
    popup_corners: 5,
    popup_font: "12px/1.5 Verdana, Arial, Helvetica, sans-serif",
    popup_nocss: "no",
    
	//Advanced settings
	div: "map",
    auto_load: "yes",
    rotate: "0",
    url_new_tab: "yes",
    images_directory: "default",
    import_labels: "no",
    fade_time: 0.1,
    link_text: "View Website"
  },
  state_specific: {
    AB: {
      name: "Alberta",
      description: "",
      color: "default",
      hover_color: "default",
      url: "javascript:;"
    },
    BC: {
      name: "British Columbia",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    SK: {
      name: "Saskatchewan",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    MB: {
      name: "Manitoba",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    ON: {
      name: "Ontario",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    QC: {
      name: "Quebec",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NB: {
      name: "New Brunswick",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    PE: {
      name: "Prince Edward Island",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NS: {
      name: "Nova Scotia",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NL: {
      name: "Newfoundland",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NU: {
      name: "Nunavut",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NT: {
      name: "Northwest Territories",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    YT: {
      name: "Yukon",
      description: "",
      color: "default",
      hover_color: "default",
      url: "default"
    }
  },
  locations: {
  },
  labels: {
    PE: {
      x: 960,
      y: 814,
      parent_id: "PE",
      pill: "yes",
      width: 65,
      display: "all"
    },
    NS: {
      x: 960,
      y: 854,
      parent_id: "NS",
      pill: "yes",
      width: 65,
      display: "all"
    },
    AB: {
      x: 232,
      y: 657,
      parent_id: "AB"
    },
    BC: {
      x: 117,
      y: 635,
      parent_id: "BC"
    },
    YT: {
      x: 75,
      y: 440,
      parent_id: "YT"
    },
    NT: {
      x: 225,
      y: 471,
      parent_id: "NT"
    },
    NU: {
      x: 429,
      y: 478,
      parent_id: "NU"
    },
    SK: {
      x: 332,
      y: 670,
      parent_id: "SK"
    },
    MB: {
      x: 430,
      y: 675,
      parent_id: "MB"
    },
    NL: {
      x: 840,
      y: 643,
      parent_id: "NL"
    },
    NB: {
      x: 837,
      y: 798,
      parent_id: "NB"
    },
    ON: {
      x: 552,
      y: 747,
      parent_id: "ON"
    },
    QC: {
      x: 718,
      y: 704,
      parent_id: "QC"
    }
  }
};

/*
,
		  "1": {
		    name: "Halifax",
		    lat: 44.6488625,
		    lng: -63.5753196,
		    color: "default",
				description: ""
		  }
*/


var mapEle = null;
var mapData = (country == 'ca' ? simplemaps_canadamap_mapdata : simplemaps_usmap_mapdata);
var regions = [];
$(function(){
	$(".region").on('change', regionUpdate);
	
  
  	$("#top_city_loading, #large_city_loading").append($("#loading_svg").clone().removeAttr('id'));
  
	$.get('https://tools.tbmbm.net/geodata/init-data?country=ca', function(data, status){
		var regions = data.regions;
		window.regions = regions;
		populateTopCity(data.topRanks);
      	populateLargeCity(data.largeCities);
		updateRegion();
      	$("#top_city_loading, #large_city_loading").html('');
	});
	
	if(country == 'ca'){
		mapEle = simplemaps_canadamap;
		mapEle.hooks.complete = function(){
										//mapEle.state_zoom('ON');
												};
	}else{
		mapEle = simplemaps_usmap;
		mapEle.hooks.complete = function(){
										//mapEle.state_zoom('ON');
												};
	}
	
	$("#single_city_frm").submit(function(e){
		e.preventDefault;
		singleCitySelected();		
		return false;
	});
	
	
	$("#compare_city_frm").submit(function(e){
		e.preventDefault;
		compareCitySelected();		
		return false;
	});
	
	$(document).on('click', ".clickable-city", singleCityClicked);
});

function populateTopCity(ranks){
  	/*
	var first = ranks.splice(0,1)[0];
	var source = document.getElementById("entry-top-single-city").innerHTML;
	var template = Handlebars.compile(source);
	var context = first;
	var resultHtml = template(context);
  
	$("#top_city").html(resultHtml);
	*/
	// rows
	for(var i=0; i <= 9; i++){
		var rowRanks = ranks.splice(0,1);
		
		var source = document.getElementById("entry-top-city-row").innerHTML;
		var template = Handlebars.compile(source);
		var context = {cities: rowRanks};
		var resultHtml = template(context);
		$("#top_city_ranks .CityRowDivHolder").eq(i).html(resultHtml);
	}
	
	
}

function populateLargeCity(ranks){
	/*
  	var first = ranks.splice(0,1)[0];
	var source = document.getElementById("entry-top-single-city").innerHTML;
	var template = Handlebars.compile(source);
  	first.rank = 1;
	var context = first;
	var resultHtml = template(context);
  	
	$("#large_city").html(resultHtml);
	*/
  
	// rows
	for(var i=0; i <= 9; i++){
		var rowRanks = ranks.splice(0,1)
      	for(var j=0; j<rowRanks.length; j++){
        	rowRanks[j].rank = i+1; //(i-1) * 2 + j +3;
      	}
		var source = document.getElementById("entry-top-city-row").innerHTML;
		var template = Handlebars.compile(source);
		var context = {cities: rowRanks};
		var resultHtml = template(context);
		$("#large_city_ranks .CityRowDivHolder").eq(i).html(resultHtml);
	}
	
	
}


function singleCityClicked(){
  var formData = "country="+window.country+"&"+$(this).data('qstr');
  $("#single_city_ranks, #single_city_top_products").empty().html($("#loading_svg").clone().removeAttr('id'));
  buildSingleCityResult(formData);
  
  setTimeout(function(){
                            $('html, body').animate({
                                              scrollTop: $("#single_city_showcase").offset().top
                                          }, 1000);
  						}, 1500);
  
}



function singleCitySelected(){
	
	var formData = {country: country, region_1: $("#region_1").val(), city_1: $("#city_1").val()};
	if(!formData.region_1 || !formData.city_1) return false;
	
  	
  	$("#single_city_ranks, #single_city_top_products").empty().html($("#loading_svg").clone().removeAttr('id'));
	
	
    buildSingleCityResult(formData);
	
} 

function buildSingleCityResult(formData){
  $.post('https://tools.tbmbm.net/geodata/get-city-ranks', formData, function(data, status){
  	$("#single_city_loading").empty();
		var finalHtml = '';
		for(var i=0; i<data.ranks.length; i++){
			var d = data.ranks[i];
			var source = document.getElementById("entry-single-rank").innerHTML;
			var template = Handlebars.compile(source);
			var context = { img: window.catImages[d.category], rank: numToRank(d.rank), category: d.category, url: d.url };
			var html = template(context);
			finalHtml += (html);
			
		}
		
		mapData.locations =[ 
			   {
				    name: data.city.name,
				    lat: data.city.lat,
				    lng: data.city.lng,
				    color: "default",
					description: ""
				  }
		  ];
		
		$("#single_city_container, #top_city_ranks, #large_city_ranks").hide();
		mapEle.refresh();
		mapEle.state_zoom(data.city.region);
		$("#single_city_ranks").html(finalHtml);
      	$("#single_city_rank").html(data.city.rank);
      	$("#single_city_rank_count").html(data.city.rankCount);

        $("#single_big_city_rank").html(data.city.bigCityRank);
      	$("#single_big_city_rank_count").html(data.city.bigRankCount);
    
      	$(".topSellingTitle").css("display","block");
    
    	$("#fav_flavr").text(data.secrets.lube);
    	$("#fav_dbsm").text(data.secrets.bdsm);
        $("#fav_roleplay").text(data.secrets.roleplay);
        $("#fav_analtoys").text(data.secrets.anal_toys);
    
    	$(".topSecret, .topSecretTitle").css("display","block");
      
      
      	$(".CityName").text(data.city.name);
      	$(".CityProvince").text(data.city.region);
      	$(".selectedCityDiv").css("display","inline-block");
        if(!data.city.bigCityRank){
          $("#bigSingleCityRank").hide();
        }
    
      
		$("#compare_city_container").show();
		// copy current city to compare form
		$("#region_2").val($("#region_1").val());
		$("#city_2").html($("#city_1").html());
		$("#city_2").val($("#city_1").val());
      	
      	$("#single_city_top_products").html(buildProductLoadingBlocks(6));
      	getTopProducts(data.top_products, data.domain, "#single_city_top_products");
   });   	
}

function buildProductLoadingBlocks(num){
 	var html = '';
  	var l = $("#loading_svg").clone().removeAttr('id');
  	for(var i =0; i<num; i++){
    	html += '<div class="ProductHolderDiv">'+l.html()+'</div>';
  	}
  	return html;
}


function compareCitySelected(){
  	
  	$("#compare_city_ranks").empty().html($("#loading_svg").clone().removeAttr('id'));
  
	var formData = {country: country, region_2: $("#region_2").val(), city_2: $("#city_2").val(), region_3: $("#region_3").val(), city_3: $("#city_3").val()};
	if(!formData.region_2 || !formData.city_2 || !formData.region_3 || !formData.city_3) return false;
	$.post('https://tools.tbmbm.net/geodata/'+'get-city-ranks', formData, function(data, status){
		var finalHtml = '';
		var city_1 = data[0];
		var city_2 = data[1];
		$("#single_city_showcase").hide();
		mapData.locations =[ 
			   {
				    name: city_1.city.name,
				    lat: city_1.city.lat,
				    lng: city_1.city.lng,
				    color: "default",
					description: ""
				  },
			  {
				    name: city_2.city.name,
				    lat: city_2.city.lat,
				    lng: city_2.city.lng,
				    color: "default",
					description: ""
				  },  
		  ];
	 	  mapEle.refresh();
	 	  if(city_1.city.region == city_2.city.region)
	 		  mapEle.state_zoom(city_1.city.region);
	 	  else{
	 		 mapEle.back();
	 	  }
	 	  
	 	var matchedRanks = [];  
	 	var city_1_overall_rank = 0, city_2_overall_rank = 0;
	 	for(var i = 0; i < city_1.ranks.length; i++){
	 		for(var j = 0; j < city_2.ranks.length; j++){
	 			if(city_1.ranks[i].category == city_2.ranks[j].category){
	 				matchedRanks.push({category: city_1.ranks[i].category, 
                                        img: window.catImages[city_1.ranks[i].category],
	 									city_1_name: city_1.city.name, 
	 									city_1_rank: numToRank(city_1.ranks[i].rank), 
	 									city_2_name: city_2.city.name, 
	 									city_2_rank: numToRank(city_2.ranks[j].rank),
                                      
                                       	rank_count: city_1.city.rankCount});
                  
	 				city_1_overall_rank += parseInt(city_1.ranks[i].rank);
	 				city_2_overall_rank += parseInt(city_2.ranks[j].rank);
	 			}
	 		}
	 	}   
	 	
	 	var winnerCity = ((city_2_overall_rank / city_2.ranks.length) < (city_1_overall_rank / city_2.ranks.length) ? city_2.city.name : city_1.city.name);
      	var winnderProvince = (city_1.city.name == winnerCity?city_1.city.region: city_2.city.region);
	 	
	 	var source = document.getElementById("compare-result").innerHTML;
		var template = Handlebars.compile(source);
      var context = { entry_compare_ranks: matchedRanks, winner:winnerCity, winnderProvince: winnderProvince, city_1: city_1.city.name, city_1_region: city_1.city.region, city_2: city_2.city.name, city_2_region: city_2.city.region };
		var resultHtml = template(context);
		$("#compare_city_ranks").html(resultHtml);
      	$(".topCategoryTitle").css("display","block");
      $(".topCategoryTitle").prependTo(".rankingCityVersus");
      
      $(".CityVersus1").text(city_1.city.name);
      $(".ProvinceVersus1").text(city_1.city.region);
      $(".CityVersus2").text(city_2.city.name);
      $(".ProvinceVersus2").text(city_2.city.region);
      
      
      
      $("#cmpCity1TopProds").data('done',0).html(buildProductLoadingBlocks(6));
      $("#cmpCity2TopProds").html(buildProductLoadingBlocks(6));
      getTopProducts(city_1.top_products, city_1.domain, "#cmpCity1TopProds");
      
      
      var city2TopProdTimer = setInterval(function(){
        if($("#cmpCity1TopProds").data('done')){
         	clearInterval(city2TopProdTimer);
          	$("#cmpCity2TopProds").data('done',0).html('');
      		getTopProducts(city_2.top_products, city_2.domain, "#cmpCity2TopProds");
        }
      });
      
      
      $('html, body').animate({
                    scrollTop: $("#compare_city_ranks").offset().top
                }, 1000);
      
	});
	
	
}


function numToRank(num) {
    var j = num % 10,
        k = num % 100;
    if (j == 1 && k != 11) {
        return num + "st";
    }
    if (j == 2 && k != 12) {
        return num + "nd";
    }
    if (j == 3 && k != 13) {
        return num + "rd";
    }
    return num + "th";
}





function getTopProducts(products, domain, topProductContainer){
  	window.productJsonPool = [];
  	window.topProductContainer = topProductContainer;
  	productPool = products;
  	requestProductJson();
}

function requestProductJson(){
  	if(window.productPool.length < 1 || window.productJsonPool.length >= window.maxProductShowing) {
    	showTopProducts();
      	return;
  	}
  	var p = window.productPool.shift();
  	if(!p) return;
    jQuery.ajax({
      type: 'GET',
      url: '/products/' + p.handle + '.json',
      success: function(response) {
        window.productJsonPool.push(response.product);
        requestProductJson();
      },
      error: function(error) {
        console.log("Error: "+ error);
      }
    });
}

function showTopProducts(){
  	$(window.topProductContainer).html('');
  	var p = window.productJsonPool.shift();
  	var allHtml = '';
  	while(p){
      	var source = document.getElementById("entry-top-product").innerHTML;
		var template = Handlebars.compile(source);
      	var context = {link: '/products/'+p.handle, img: p.image.src, name: p.title, price: p.variants[0].price, pid:  p.variants[0].id};
		allHtml += template(context);
      	
    	p = window.productJsonPool.shift();
  	}
  
  	$(window.topProductContainer).data('done',1).html(allHtml);
}





function citySelected(){
	var selected = $(this).val();
	if(!selected) return;
	
	
	// refresh page to build the map.
} 
function updateRegion(){
	 
	$(".region").each(function(){
		$(this).find('option').not(':first').remove();
		for(var i = 0; i<window.regions.length; i++){
			$(this).append(new Option(window.regions[i].name,window.regions[i].id));
		}
	});
	
}

function updateCity(index, cities){
	var city = $("#city_"+index)
	city.find('option').not(':first').remove();
	for(var i = 0; i<cities.length; i++){
		city.append(new Option(cities[i].name,cities[i].name));
	}
}

function regionUpdate(){
	var sourceId = $(this).attr('id');
	var index = sourceId.split('_')[1];
	
	
	$("#city_"+index).removeAttr('disabled');
	var cities = [];
	var selected = $(this).val();
	if(!selected) updateCity(cities);
	$.get(window.mapAjaxUrl+'get-city?country='+country+"&region="+selected, function(data, status){
		updateCity(index,data);
	});
}
